import { getShoppingEntryRouteName } from '../discovery-shopping';
import { useAppRouter } from './useDynamicRouter';
import { useMonolithQuery } from './useMonolithQuery';

type UseNavigateToShoppingArgs = {
  employeeId?: string;
  employerId?: string;
};

export function useNavigateToShopping({
  employeeId,
  employerId,
}: UseNavigateToShoppingArgs): {
  navigateToShopping: () => void;
  isLoading: boolean;
} {
  const { navigateToRoute } = useAppRouter();
  const { data: isOnForEmployee = false, isLoading: isEmployeeFlagLoading } =
    useMonolithQuery({
      method: 'featureFlagControllerEmployeeOn',
      params: employeeId && ['discovery_shopping', employeeId],
    });
  const { data: isOnForEmployer = false, isLoading: isEmployerFlagLoading } =
    useMonolithQuery({
      method: 'featureFlagControllerEmployerOn',
      params: employerId && ['discovery_shopping_employer', employerId],
    });

  const isDiscoveryShoppingOn = isOnForEmployee || isOnForEmployer;

  return {
    navigateToShopping: () =>
      navigateToRoute(getShoppingEntryRouteName(isDiscoveryShoppingOn), []),
    isLoading: isEmployeeFlagLoading || isEmployerFlagLoading,
  };
}
